export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-20 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20flowing%20geometric%20patterns%20in%20golden%20and%20cream%20tones%2C%20subtle%20texture%2C%20professional%20corporate%20style%2C%20clean%20and%20modern%2C%20no%20text%2C%20high%20quality%20digital%20art&width=1800&height=600&seq=cta-bg-2026&orientation=landscape)`,
        }}
        role="presentation"
      />
      <div className="absolute inset-0 bg-background-900/75" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" style={{ fontFamily: "var(--font-heading)" }}>
          准备好开始使用 91.cn 了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 leading-relaxed">
          立即注册 91.cn，免费体验全部基础功能，感受高效便捷的互联网服务。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            type="button"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-medium whitespace-nowrap cursor-pointer rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200"
          >
            免费注册
          </button>
          <button
            type="button"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-medium whitespace-nowrap cursor-pointer rounded-md bg-white/15 text-white hover:bg-white/25 backdrop-blur-sm border border-white/30 transition-all duration-200"
          >
            联系销售
          </button>
        </div>
      </div>
    </section>
  );
}